<template>
  <div class="wrapper">
    <!-- Mobile overlay -->
    <div class="sidebar-overlay" :class="{ active: sidebarOpen }" @click="closeSidebar"></div>

    <!-- Sidebar -->
    <div class="sidebar-custom" :class="{ 'sidebar-open': sidebarOpen }">
      <div class="sidebar-content">
        <div class="sidebar-header">
          <div class="brand-wrapper">
            <div class="brand-logo-box">P</div>
            <div class="brand-text">
              <span class="brand-name">SellerPeak</span>
              <span class="brand-version">v{{ appVersion }}</span>
            </div>
          </div>
          <div class="id-badge">ID: {{ sklads.secret_code }}</div>
        </div>

        <div class="sidebar-nav-container">
          <side-bar>
            <template slot="links">
              <div class="menu-section">
                <sidebar-item :link="{ name: 'Bosh sahifa', icon: 'bi bi-pie-chart-fill', path: '/' }" />
                <div class="menu-divider">SAVDO</div>
                <sidebar-item :link="{ name: 'Savdolar ro\'yxati', icon: 'bi bi-list-check', path: '/chiqim/index' }" />
                <sidebar-item :link="{ name: 'Savdo (POS)', icon: 'bi bi-calculator-fill', path: '/chiqim/pos' }" class="pos-item" />
                <sidebar-item :link="{ name: 'Qaytarishlar', icon: 'bi bi-arrow-return-left', path: '/refund/index' }" />
                <sidebar-item :link="{ name: 'Zakazlar', icon: 'bi bi-journal-check', path: '/zakazlar/index' }" />
                <sidebar-item :link="{ name: 'Ombor (Qoldiq)', icon: 'bi bi-boxes', path: '/ombor' }" />
                <!-- <sidebar-item :link="{ name: 'Revizya', icon: 'bi bi-clipboard-check-fill', path: '/revision/index' }" /> -->
                <sidebar-item :link="{ name: 'Tezkor revizya', icon: 'bi bi-lightning-charge-fill', path: '/revision/quick' }" />
                <sidebar-item :link="{ name: 'Ta\'minot (Kirim)', icon: 'bi bi-truck', path: '/kirim/index' }" />

                <div class="menu-divider">MOLIYA</div>
                <sidebar-item :link="{ name: 'Xarajatlar', icon: 'bi bi-wallet2', path: '/xarajatlar/index' }" />
                <sidebar-item :link="{ name: 'Nasiyalar', icon: 'bi bi-cash-stack', path: '/nasiyalar' }" />
                <sidebar-item :link="{ name: 'Ustalar', icon: 'bi bi-person-badge-fill', path: '/usta/index' }" />
                <sidebar-item :link="{ name: 'Ustaga sovg\'a', icon: 'bi bi-gift', path: '/usta/give-product' }" />
                <sidebar-item :link="{ name: 'Aksiyalar', icon: 'bi bi-gift-fill', path: '/aksiya/index' }" />

                <div class="menu-divider">BOSHQARUV</div>
                <sidebar-item :link="{ name: 'Hisobot', icon: 'bi bi-pie-chart-fill', path: '/xisobot/dashboard' }" />
                <sidebar-item :link="{ name: 'Xodimlar reytingi', icon: 'bi bi-trophy-fill', path: '/xisobot/staff-sales' }" />
                <sidebar-item :link="{ name: 'Foyda-Zarar', icon: 'bi bi-graph-up-arrow', path: '/xisobot/profit-detail' }" />
                <sidebar-item :link="{ name: 'Xodimlar balansi', icon: 'bi bi-wallet-fill', path: '/salary/balance' }" />
                <sidebar-item :link="{ name: 'Mahsulotlar hisoboti', icon: 'bi bi-boxes', path: '/xisobot/products-inventory' }" />
                <sidebar-item :link="{ name: 'Kassa hisoboti', icon: 'bi bi-cash-stack', path: '/xisobot/kassa-summary' }" />

                <div class="menu-divider">Ma'lumotlar</div>
                <sidebar-item :link="{ name: 'Paketlar', icon: 'bi bi-box-seam', path: '/paket/index' }" />
                <sidebar-item :link="{ name: 'Brendlar', icon: 'bi bi-box-seam', path: '/brand/index' }" />
                <sidebar-item :link="{ name: 'Kurs', icon: 'bi bi-box-seam', path: '/malumot/dollar/index' }" />
                <sidebar-item :link="{ name: 'Tolov turlari', icon: 'bi bi-credit-card-fill', path: '/pay-type/index' }" />
                <sidebar-item :link="{ name: 'Modellar', icon: 'bi bi-box-seam', path: '/model/index' }" />
                <sidebar-item :link="{ name: 'Brand/Model sozlash', icon: 'bi bi-tags-fill', path: '/product-brand-model/index' }" />
                <sidebar-item :link="{ name: 'Mijozlar', icon: 'bi bi-people-fill', path: '/malumot/kontragent/index' }" />
                <sidebar-item :link="{ name: 'Ta\'minotchilar', icon: 'bi bi-truck-flatbed', path: '/taminotchi/index' }" />
                <sidebar-item :link="{ name: 'Maxsulotlar', icon: 'bi bi-people-fill', path: '/directory/product/index' }" />
                <!-- <sidebar-item :link="{ name: 'Takliflar', icon: 'bi bi-bullseye', path: '/offers' }" /> -->
                <!-- <sidebar-item :link="{ name: 'Kontaktlar', icon: 'bi bi-people-fill', path: '/contact' }" /> -->
                <sidebar-item :link="{ name: 'Skladlar', icon: 'bi bi-people-fill', path: '/malumot/sklad/index' }" />
                <sidebar-item :link="{ name: 'Foydalanuvchilar', icon: 'bi bi-gear-fill', path: '/malumot/user/index' }" />
              </div>
            </template>
          </side-bar>
        </div>
      </div>
    </div>

    <!-- Main Panel -->
    <div class="main-panel" :style="mainPanelStyle">
      <!-- Top Bar -->
      <div class="topbar">
        <button class="toggle-btn" @click="toggleSidebar" :title="sidebarOpen ? 'Yopish' : 'Ochish'">
          <i :class="sidebarOpen ? 'bi bi-blockquote-left' : 'bi bi-list'"></i>
        </button>
        <span class="topbar-title">SELLERPEAK</span>

        <!-- Language switcher -->
        <div class="lang-switcher">
          <button
            v-for="l in languages"
            :key="l.code"
            class="lang-btn"
            :class="{ active: currentLocale === l.code }"
            @click="changeLocale(l.code)"
            :title="l.label"
          >
            <span class="lang-flag">{{ l.flag }}</span>
            <span class="lang-code">{{ l.short }}</span>
          </button>
        </div>
      </div>

      <div class="content-view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { version } from '../../../package.json';

export default {
  data() {
    return {
      sklads: { secret_code: "AA" },
      appVersion: version,
      rules: [],
      sidebarOpen: true,
      isDesktop: true,
      languages: [
        { code: 'uz',    short: 'UZ', label: "O'zbekcha", flag: '🇺🇿' },
        { code: 'ru',    short: 'RU', label: 'Русский',   flag: '🇷🇺' },
        { code: 'china', short: 'CN', label: '中文',       flag: '🇨🇳' },
      ],
    };
  },
  computed: {
    currentLocale() {
      return this.$store.state.locale || 'uz';
    },
    mainPanelStyle() {
      return {
        float: 'none',
        width: 'auto',
        marginLeft: (this.isDesktop && this.sidebarOpen) ? '260px' : '0px',
        transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      };
    }
  },
  watch: {
    $route() {
      // Mobileda sahifa o'zgarganda sideberni yopish
      if (window.innerWidth < 992) {
        this.sidebarOpen = false;
      }
    }
  },
  mounted() {
    this.isDesktop = window.innerWidth >= 992;
    this.sidebarOpen = this.isDesktop;

    window.addEventListener('resize', this.handleResize);

    const savedRules = localStorage.getItem("rules");
    if (savedRules) {
      this.rules = JSON.parse(savedRules);
    }

    axios.get("api/v1/sklads/id/1").then(response => {
      this.sklads = response.data;
    }).catch(err => console.log(err));
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    changeLocale(code) {
      this.$store.commit('SET_LOCALE', code);
      this.$i18n.locale = code;
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 992;
      if (this.isDesktop) {
        this.sidebarOpen = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ─── Sidebar ───────────────────────────────────────────────────────────────
.sidebar-custom {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 260px;
  background-color: #0f172a;
  z-index: 1050;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  transform: translateX(-260px);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.sidebar-open {
    transform: translateX(0);
  }

  .sidebar-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

// ─── Sidebar Header ────────────────────────────────────────────────────────
.sidebar-header {
  padding: 24px 20px 16px;

  .brand-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;

    .brand-logo-box {
      background: #2563eb;
      color: white;
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      font-weight: 800;
      font-size: 22px;
    }

    .brand-name {
      color: white;
      font-weight: 800;
      font-size: 19px;
      font-style: italic;
      display: block;
    }

    .brand-version {
      color: #10b981;
      font-size: 10px;
      font-weight: 800;
      display: block;
    }
  }

  .id-badge {
    opacity: 0.6;
    font-size: 10px;
    margin-top: 6px;
    color: #94a3b8;
  }
}

// ─── Sidebar Nav ───────────────────────────────────────────────────────────
.sidebar-nav-container {
  flex: 1;
  overflow-y: auto;
  padding: 10px 15px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #334155;
    border-radius: 4px;
  }
}

.menu-divider {
  padding: 20px 15px 10px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

// ─── Sidebar Items (global override) ──────────────────────────────────────
::v-deep {
  .sidebar-item {
    margin-bottom: 3px;

    .nav-link {
      color: #94a3b8 !important;
      padding: 10px 15px !important;
      border-radius: 10px !important;
      display: flex;
      align-items: center;
      transition: background 0.15s, color 0.15s;

      p {
        margin: 0 !important;
        font-size: 14px;
        font-weight: 600 !important;
      }

      i {
        font-size: 17px;
        margin-right: 12px;
        width: 20px;
        text-align: center;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.06) !important;
        color: #e2e8f0 !important;
      }
    }

    &.active > .nav-link {
      background: #2563eb !important;
      color: white !important;
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    }
  }
}

// ─── Mobile Overlay ────────────────────────────────────────────────────────
.sidebar-overlay {
  display: none;

  @media (max-width: 991px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 1040;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;

    &.active {
      opacity: 1;
      pointer-events: all;
    }
  }
}

// ─── Topbar ────────────────────────────────────────────────────────────────
.topbar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 20px;
  height: 56px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  .toggle-btn {
    background: none;
    border: none;
    cursor: pointer;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    color: #334155;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;
    flex-shrink: 0;
    background: #2563eb;
    &:hover {
      background: #10b981;
    }

    &:focus {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }
  }

  .topbar-title {
    font-weight: 800;
    font-style: italic;
    font-size: 16px;
    color: #1e293b;

    // Desktop da sidebar ochiq bo'lganda title ko'rinmasin
    @media (min-width: 992px) {
      display: none;
    }
  }

  .lang-switcher {
    margin-left: auto;
    display: flex;
    gap: 4px;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 10px;

    .lang-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 4px 10px;
      border: none;
      background: transparent;
      border-radius: 7px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 700;
      color: #64748b;
      transition: 0.15s;
      line-height: 1;

      .lang-flag { font-size: 15px; }
      .lang-code { font-size: 11px; letter-spacing: 0.5px; }

      &:hover { background: #e2e8f0; color: #1e293b; }

      &.active {
        background: #2563eb;
        color: white;
        box-shadow: 0 2px 6px rgba(37, 99, 235, 0.25);
      }
    }

    @media (max-width: 560px) {
      .lang-btn {
        padding: 4px 6px;
        .lang-code { display: none; }
      }
    }
  }
}

// ─── Main Panel ────────────────────────────────────────────────────────────
.main-panel {
  height: 100vh;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  // margin-left va transition inline :style orqali boshqariladi
}

.content-view {
  padding: 0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
</style>
